/* Kaio-Dia - etat initial du bloc d onglets.

   Sur grand ecran le bloc s affiche en onglets : un panneau est forcement
   ouvert, c est le principe. Sur mobile il devient un accordeon, et la
   demande est que tout soit replie au chargement : le visiteur ouvre
   "Details du produit" en tapant sur l accordeon, ou via le lien de lecture
   place sous l apercu de description.

   kd-product.js ouvre le premier panneau au demarrage pour que le mode
   onglets fonctionne. Ce script repasse derriere lui sur mobile et replie
   tout, puis suit les changements de largeur d ecran pour que la rotation
   d un telephone ne laisse pas la page dans un etat incoherent.

   Fichier maison, jamais ecrase par une mise a jour de FullStack. */
(function () {
  'use strict';

  var DESKTOP = '(min-width: 750px)';

  function isDesktop() {
    return window.matchMedia && window.matchMedia(DESKTOP).matches;
  }

  function collapseAll() {
    var panels = document.querySelectorAll('[data-kd-tabs] [data-kd-panel]');
    for (var i = 0; i < panels.length; i++) {
      panels[i].classList.remove('is-open');
      var head = panels[i].querySelector('[data-kd-panel-toggle]');
      if (head) head.setAttribute('aria-expanded', 'false');
    }
  }

  /* Retour en mode onglets : le panneau marque actif doit redevenir ouvert,
     sinon la zone de contenu reste vide. */
  function restoreActive() {
    var roots = document.querySelectorAll('[data-kd-tabs]');
    for (var i = 0; i < roots.length; i++) {
      var active = roots[i].querySelector('[data-kd-panel].is-active');
      if (!active) active = roots[i].querySelector('[data-kd-panel]');
      if (!active) continue;
      active.classList.add('is-active', 'is-open');
      var head = active.querySelector('[data-kd-panel-toggle]');
      if (head) head.setAttribute('aria-expanded', 'true');
    }
  }

  function apply() {
    if (isDesktop()) restoreActive();
    else collapseAll();
  }

  function boot() {
    /* kd-product.js ouvre le premier panneau dans son propre boot ; on passe
       apres lui, d ou le setTimeout a zero. */
    setTimeout(apply, 0);

    if (window.matchMedia) {
      var mq = window.matchMedia(DESKTOP);
      if (mq.addEventListener) mq.addEventListener('change', apply);
      else if (mq.addListener) mq.addListener(apply);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
